import { useEffect, useState } from 'react';
import { getSquadDetails } from '../services/squadApi';

export function useSquadDetails(squadId) {
  const [squadDetails, setSquadDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchSquadDetails() {
      try {
        const data = await getSquadDetails(squadId);
        setSquadDetails(data);
      } catch (error) {
        console.error('Error fetching squad details:', error);
      } finally {
        setIsLoading(false);
      }
    }

    if (squadId) {
      fetchSquadDetails();
    } else {
      setIsLoading(false);
    }
  }, [squadId]);

  const refreshSquadDetails = async () => {
    try {
      const data = await getSquadDetails(squadId);
      setSquadDetails(data);
      return data;
    } catch (error) {
      console.error('Error refreshing squad details:', error);
      return null;
    }
  };

  return { squadDetails, isLoading, refreshSquadDetails, setSquadDetails };
}
